// src/pages/Appointments/constants/appointments.constant.js

import {
  CalendarIcon,
  ClockIcon,
  CheckCircleIcon,
  UserAddIcon,
  ChartBarIcon,
  ClipboardListIcon,
  ExclamationCircleIcon,
  PlayIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import { FiCalendar, FiUsers, FiActivity, FiClock } from "react-icons/fi";

// ========================================
// APPOINTMENT ROUTES
// ========================================
export const APPOINTMENT_ROUTES = {
  // Root
  ROOT: "/appointments",
  DASHBOARD: "/appointments",

  // List Views
  LIST: "/appointments/list",
  TODAY: "/appointments/today",
  UPCOMING: "/appointments/upcoming",
  PENDING: "/appointments/pending",
  SEARCH: "/appointments/search",

  // Visit Tracking
  ACTIVE_VISITS: "/appointments/active-visits",

  // Actions
  BOOK: "/appointments/book",
  CALENDAR: "/appointments/calendar",

  // Single Appointment (dynamic)
  DETAILS: "/appointments/:id",
  RESCHEDULE: "/appointments/:id/reschedule",

  // Analytics
  ANALYTICS: "/appointments/analytics",
};

// ========================================
// APPOINTMENT PERMISSIONS
// ========================================
export const APPOINTMENT_PERMISSIONS = {
  // View Permissions
  VIEW_APPOINTMENTS: "VIEW_APPOINTMENTS",
  VIEW_ALL_BRANCHES: "VIEW_ALL_BRANCH_APPOINTMENTS",
  VIEW_ANALYTICS: "VIEW_APPOINTMENT_ANALYTICS",

  // Manage Permissions
  CREATE_APPOINTMENTS: "CREATE_APPOINTMENTS",
  EDIT_APPOINTMENTS: "EDIT_APPOINTMENTS",
  DELETE_APPOINTMENTS: "DELETE_APPOINTMENTS",
  RESCHEDULE_APPOINTMENTS: "RESCHEDULE_APPOINTMENTS",

  // Visit Tracking Permissions
  CHECK_IN_CUSTOMERS: "CHECK_IN_CUSTOMERS",
  TRACK_VISITS: "TRACK_VISITS",
  COMPLETE_VISITS: "COMPLETE_VISITS",

  // Admin Permissions
  MANAGE_APPOINTMENT_SETTINGS: "MANAGE_APPOINTMENT_SETTINGS",
  APPROVE_APPOINTMENTS: "APPROVE_APPOINTMENTS",
  ADMIN: "APPOINTMENT_ADMIN",
};

// ========================================
// APPOINTMENT STATUS
// ========================================
export const APPOINTMENT_STATUS = {
  SCHEDULED: "scheduled",
  CONFIRMED: "confirmed",
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  NO_SHOW: "no_show",
  RESCHEDULED: "rescheduled",
};

// ========================================
// VISIT STATUS
// ========================================
export const VISIT_STATUS = {
  NOT_STARTED: "not_started",
  CHECKED_IN: "checked_in",
  IN_CONSULTATION: "in_consultation",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};
